// src/utils/pricing.ts
// NOTE: Ce fichier est maintenant un wrapper pour le service centralisé
// Importez directement depuis @/services/pricingService pour les nouveaux fichiers

import {
  formatPrice as formatPriceService,
  calculateTTC as calculateTTCService,
  calculateHT as calculateHTService,
  computeDiscountedPrice as computeDiscountedPriceService,
  type Promotion,
  type PricingInfo
} from '@/services/pricingService';

// Exports pour rétrocompatibilité
export const formatPrice = formatPriceService;
export const calculateTTC = calculateTTCService;
export const calculateHT = calculateHTService;
export const computeDiscountedPrice = computeDiscountedPriceService;

// Re-export types
export type { Promotion, PricingInfo };
